/**
 * @file 邀请码相关
 * 
 */
import axiosInstance from './axiosInstance';

// 查询wait list信息
export const getWaitListInfoApi = async () => {
  try {
    const response = await axiosInstance.get(`/ads/waitlist/info`);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 加入waitlist
export const joinWaitListApi = async () => {
  try {
    const response = await axiosInstance.post(`/ads/waitlist/join`);
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};

// 验证产品邀请码
export const verifyProductCodeApi = async (code: string) => {
  try {
    const response = await axiosInstance.post(`/ads/waitlist/productCode`, {code});
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};

// 验证注册邀请码
export const verifyRegisterCodeApi = async (code: string) => {
  try {
    const response = await axiosInstance.post(`/ads/waitlist/invitationCode`, {code});
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};

// 发送邀请邮件
export const emailInviteApi = async (params: {email: string, url: string}) => {
  try {
    const response = await axiosInstance.post(`/ads/waitlist/emailInvite`, params);
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};